import type { RNGConfig } from '../rng/RNGConfig.type'
import type { State } from '../state/State.type'
import { randomId } from '../util/rand'
import createBlankPlayer from './createBlankPlayer'
import nextMapEditorPlayer from './nextMapEditorPlayer'
import type { Player } from './Player.type'

export default function createMapEditorPlayer(state: State, rng: RNGConfig): Player {
  const id: number = randomId(state.players, rng)
  const cnp = nextMapEditorPlayer(state)
  const player = createBlankPlayer(id, cnp)
  return player
}
